import { FunctionComponent, ReactNode, useState } from "react";
import TextFieldAtom from "../../../../../src/atoms/textfield";
import BasicButton, { BasicButtonType } from "../../../buttons/basic";

export type TextFieldButtonType = {
  /** Variant props */
  indicator?: "neutral" | "fail" | "success";
  state?: "default" | "disabled";
  type?: "outline" | "fill";
  variant?: "labelled" | "labelless";

  id?: string;
  name?: string;
  className?: string;
  label?: string;
  message?: string;
  placeholder?: string;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  isRequired?: boolean;
  optionalText?: string;
  maxLength?: number;
  showCharacterCounter?: boolean;
  inputType?: "text" | "password" | "number" | "email" | "tel" | "url";
  size?: "lg" | "sm";
  value?: string | number;
  button?: BasicButtonType;
  buttonPosition?: "right" | "bottom";
  hideButton?: boolean;
  messages?: {
    text: string;
    type: "neutral" | "fail" | "success";
    icon?: ReactNode;
  }[];
  onChange?: (value: string | number) => void;
};

export const TextFieldGroupButton: FunctionComponent<TextFieldButtonType> = ({
  id,
  name,
  label = "Label",
  iconLeft,
  iconRight,
  button,
  state,
  hideButton = false,
  indicator = "neutral",
  buttonPosition = "bottom",
  variant = "labelled",
  size = "lg",
  ...props
}) => {
  const buttonSize = variant === "labelled" || size === "lg" ? "md" : size;
  const [isFocused, setIsFocused] = useState(false);

  const Button = () => {
    return (
      <>
        {!hideButton && indicator !== "fail" && indicator !== "success" && (
          <BasicButton
            state={!isFocused ? "disabled" : state} // This should first so that consumers can use loading state if needed
            label={"Label"}
            {...button}
            className={`quill-ui-next-textfield-button ${
              buttonPosition === "right" ? "right" : "bottom"
            } ${variant} ${size} ${button?.className}`}
            size={buttonSize}
            style="primary"
            width={
              buttonPosition === "right" ? "hug content" : "fill container"
            }
            color="blackWhite"
          />
        )}
      </>
    );
  };

  return (
    <TextFieldAtom
      id={id}
      name={name}
      {...props}
      size={size}
      variant={variant}
      indicator={indicator}
      state={state}
      label={label}
      iconLeft={iconLeft}
      iconRight={indicator !== "fail" && indicator !== "success" && iconRight}
      contentRight={buttonPosition === "right" && <Button />}
      customInnerContent={buttonPosition === "bottom" && <Button />}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
    />
  );
};

TextFieldGroupButton.displayName = "TextFieldGroupButton";

export default TextFieldGroupButton;
